if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        const variantId = formData.get('id');
        const quantity = parseInt(formData.get('quantity')) || 1;
        const linesUpdateDeferred = this.createCartLinesUpdateEvent(variantId, quantity);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: variantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              this.dispatchCartErrorEvent(response.description || response.message, 'INVALID');
              linesUpdateDeferred?.reject(new Error(response.description || response.message));

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              this.resolveCartLinesUpdate(linesUpdateDeferred);
              window.location = window.routes.cart_url;
              return;
            }

            this.resolveCartLinesUpdate(linesUpdateDeferred);

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: variantId,
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
            this.dispatchCartErrorEvent(e.message || 'Network error', 'SERVICE_UNAVAILABLE');
            linesUpdateDeferred?.reject(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      createCartLinesUpdateEvent(variantId, quantity) {
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return null;

        const deferred = CartLinesUpdateEvent.createPromise();
        this.dispatchEvent(
          new CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: [{ merchandiseId: variantId, quantity }],
            promise: deferred.promise,
          })
        );
        return deferred;
      }

      resolveCartLinesUpdate(deferred) {
        if (!deferred) return;
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return;

        const pendingCartDataPromise = typeof CartItems !== 'undefined'
          ? CartItems.fetchCartData()
          : fetch(`${routes.cart_url}.json`).then((response) => response.json());

        pendingCartDataPromise
          .then((cart) => {
            if (!cart?.currency) return deferred.reject(new Error('Missing currency in cart response'));
            deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart) });
          })
          .catch((e) => deferred.reject(e));
      }

      dispatchCartErrorEvent(message, code) {
        const { CartErrorEvent } = window.StandardEvents || {};
        if (!CartErrorEvent) return;
        this.dispatchEvent(new CartErrorEvent({ error: message, code }));
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

/* ============================================================
   CARRIOUS — PREMIUM BAG QUICK ADD V4
   Fixes Dawn card-link overlay interception without changing cards.
   Developed By ATIKA ABDUL HAMEED
   ============================================================ */
(function initCarriousBagQuickAddV4() {
  if (window.__carriousBagQuickAddV4) return;
  window.__carriousBagQuickAddV4 = true;

  const selector = '[data-atika-bag-button]';
  let hoveredBag = null;

  function injectBagInteractionStyles() {
    if (document.getElementById('carrious-bag-interaction-v4')) return;

    const style = document.createElement('style');
    style.id = 'carrious-bag-interaction-v4';
    style.textContent = `
      ${selector}.carrious-hover {
        background: #111 !important;
        color: #fff !important;
        border-color: rgba(17,17,17,.9) !important;
        transform: translateY(-2px) scale(1.045) !important;
        box-shadow: 0 11px 24px rgba(0,0,0,.14), 0 3px 8px rgba(0,0,0,.06) !important;
      }
      ${selector}.carrious-hover::before {
        opacity: .68 !important;
        transform: scale(1.02) !important;
      }
      ${selector}.carrious-hover .atika-product-bag__icon {
        transform: translateY(-.5px) scale(1.075) !important;
      }
      ${selector}.carrious-hover .atika-product-bag__icon circle {
        fill: #111 !important;
      }
      ${selector}.carrious-pressed {
        transform: translateY(0) scale(.94) !important;
        transition-duration: .12s !important;
      }
      ${selector}.is-error {
        animation: carriousBagNudge .28s ease both;
      }
      @keyframes carriousBagNudge {
        0%,100% { transform: translateX(0); }
        35% { transform: translateX(-2px); }
        70% { transform: translateX(2px); }
      }
    `;
    document.head.appendChild(style);
  }

  function pointInside(element, x, y) {
    if (!element) return false;
    const rect = element.getBoundingClientRect();
    return x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;
  }

  function bagFromEvent(event) {
    const direct = event.target?.closest?.(selector);
    if (direct) return direct;

    const card = event.target?.closest?.('.card-wrapper, .product-card-wrapper');
    if (!card) return null;

    const bag = card.querySelector(selector);
    if (!bag) return null;

    return pointInside(bag, event.clientX, event.clientY) ? bag : null;
  }

  function setHoverBag(bag) {
    if (hoveredBag === bag) return;

    if (hoveredBag) hoveredBag.classList.remove('carrious-hover');
    hoveredBag = bag || null;

    if (hoveredBag && !hoveredBag.disabled) {
      hoveredBag.classList.add('carrious-hover');
    }
  }

  async function addBagProduct(bag) {
    if (!bag || bag.disabled || bag.dataset.carriousBusy === '1') return;

    const variantId = bag.getAttribute('data-variant-id');
    if (!variantId) return;

    bag.dataset.carriousBusy = '1';
    bag.classList.remove('is-error', 'is-added', 'carrious-pressed');
    bag.classList.add('is-loading');
    bag.setAttribute('aria-busy', 'true');

    try {
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const formData = new FormData();

      formData.append('id', variantId);
      formData.append('quantity', '1');

      if (cart && typeof cart.getSectionsToRender === 'function') {
        const sectionIds = cart.getSectionsToRender().map((section) => section.id);
        formData.append('sections', sectionIds);
        formData.append('sections_url', window.location.pathname);

        if (typeof cart.setActiveElement === 'function') {
          cart.setActiveElement(bag);
        }
      }

      const config = typeof fetchConfig === 'function'
        ? fetchConfig('javascript')
        : { method: 'POST', headers: { Accept: 'application/json' } };

      config.method = 'POST';
      config.headers = config.headers || {};
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;

      const addResponse = await fetch(window.routes?.cart_add_url || '/cart/add.js', config);
      const response = await addResponse.json();

      if (!addResponse.ok || response?.status) {
        throw new Error(response?.description || response?.message || 'Unable to add product to cart.');
      }

      bag.classList.remove('is-loading');
      bag.classList.add('is-added');
      bag.removeAttribute('aria-busy');

      if (cart && typeof cart.renderContents === 'function' && response.sections) {
        cart.renderContents(response);
      } else {
        const cartIcon = document.querySelector('#cart-icon-bubble');
        if (cartIcon) cartIcon.click();
      }

      if (
        typeof publish === 'function' &&
        typeof PUB_SUB_EVENTS !== 'undefined' &&
        PUB_SUB_EVENTS.cartUpdate
      ) {
        try {
          await publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'carrious-bag-quick-add',
            productVariantId: variantId,
            cartData: response,
          });
        } catch (e) {}
      }

      setTimeout(() => bag.classList.remove('is-added'), 850);
    } catch (error) {
      console.error('[CARRIOUS] Bag quick add failed:', error);
      bag.classList.remove('is-loading');
      bag.classList.add('is-error');
      bag.removeAttribute('aria-busy');
      setTimeout(() => bag.classList.remove('is-error'), 450);
    } finally {
      setTimeout(() => {
        delete bag.dataset.carriousBusy;
        bag.classList.remove('is-loading', 'carrious-pressed');
        bag.removeAttribute('aria-busy');
      }, 500);
    }
  }

  injectBagInteractionStyles();

  window.addEventListener(
    'pointermove',
    (event) => {
      if (event.pointerType && event.pointerType !== 'mouse' && event.pointerType !== 'pen') return;
      setHoverBag(bagFromEvent(event));
    },
    true
  );

  window.addEventListener(
    'pointerdown',
    (event) => {
      const bag = bagFromEvent(event);
      if (!bag || bag.disabled) return;
      bag.classList.add('carrious-pressed');
    },
    true
  );

  window.addEventListener(
    'pointerup',
    () => {
      document.querySelectorAll(`${selector}.carrious-pressed`).forEach((bag) => {
        bag.classList.remove('carrious-pressed');
      });
    },
    true
  );

  window.addEventListener(
    'click',
    (event) => {
      const bag = bagFromEvent(event);
      if (!bag) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (bag.disabled) return;
      addBagProduct(bag);
    },
    true
  );

  window.addEventListener('blur', () => setHoverBag(null));
})();
